module.exports = __webpack_public_path__ + "static/media/request_a_quote.9e6424cd.png";